"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FunnelQuestion = _interopRequireDefault(require("./FunnelQuestion"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _FunnelQuestion.default;
exports.default = _default;